<div class="wrapper">
  <div class="table-container">
    <div class="d-flex filters">
      <div class="form-group">
        <label for="layer">{{'Layer:' | translate}}</label>
        <select id="layer" class="custom-select custom-select-sm"
                [(ngModel)]="selectedLayer">
          <option selected disabled>{{'Select layer' | translate}}</option>
          <option *ngFor="let layer of layers" [ngValue]="layer.id">{{layer.name | translate}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="prefix">{{'Prefix:' | translate}}</label>
        <input id="prefix" class="form-control form-control-sm"
               [(ngModel)]="prefix"
               placeholder="{{'Prefix for automap' | translate}}">
      </div>
      <div class="form-group">
        <label for="postfix">{{'Postfix:' | translate}}</label>
        <input id="postfix" class="form-control form-control-sm"
               [(ngModel)]="postfix"
               placeholder="{{'Postfix for automap' | translate}}">
      </div>
      <button [attr.data-btnId]="getElementId('automap')" class="btn btn-outline-primary btn-sm" (click)="automap()">
        Automap
      </button>
    </div>
    <table class="table table-sm">
      <thead>
      <tr>
        <th style="width: 40%;">
          {{'MISONET name' | translate}}
        </th>
        <th style="width: 60%;">
          {{'REGO mapping' | translate}}
        </th>
      </tr>
      </thead>
      <tbody>
      <!--<div class="tile-container-scrollable">-->
      <ng-template ngFor let-device [ngForOf]="deviceList">
        <tr>
          <td style="width: 40%;">{{device}}</td>
          <td style="width: 60%;">
            <span
              *ngIf="device !== editDevice; else editor;"
              class="clickable"
              [ngClass]="{
                'text-danger': !mappingList[device]
              }"
              (click)="setEditDevice(device);"
            >
              <ng-container *ngIf="mappingList[device];">
                {{getTitle(mappingList[device].regoId)}}
              </ng-container>
              <ng-container *ngIf="!mappingList[device];">
                {{'Device not mapped' | translate}}
              </ng-container>
            </span>
          </td>
        </tr>
      </ng-template>
      <!--</div>-->
      </tbody>
    </table>

  </div>
</div>

<ng-template #editor>
  <div class="d-flex">
    <div style="flex-grow: 1;">
      <input id="typeahead-format" type="text"
             [(ngModel)]="currentMapping"
             [ngbTypeahead]="search"
             [resultFormatter]="getMapObjectTitle"
             [inputFormatter]="getMapObjectTitle"
             container="body"
             class="form-control form-control-sm" />
    </div>
    <div style="margin: 0 10px;">
      <a [attr.data-btnId]="getElementId('saveDeviceMapping')" class="text-success" (click)="saveDeviceMapping();">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#check"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('setEditDevice')" class="text-info" (click)="setEditDevice('');">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#times"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('unMapDevice')" class="text-info" (click)="UnMapDevice()">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#trash"></use>
        </svg>
      </a>
    </div>
  </div>
</ng-template>

<i class="far fa-check" data-fa-symbol="check"></i>
<i class="far fa-times" data-fa-symbol="times"></i>
<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
